import { useState } from 'react';
import { QUIZ_META, PERGUNTAS, calcularResultado, CTA } from '../lib/quizConfig';
import QuizQuestion from '../components/quiz/QuizQuestion';
import QuizResult   from '../components/quiz/QuizResult';

const ETAPA = { INTRO: 'intro', QUIZ: 'quiz', RESULTADO: 'resultado' };

export default function QuizPage() {
  const [etapa, setEtapa]         = useState(ETAPA.INTRO);
  const [atual, setAtual]         = useState(0);
  const [respostas, setRespostas] = useState({});   // { 1: "A", 2: "C", ... }
  const [resultado, setResultado] = useState(null);

  const responder = (letra) => {
    const pergunta = PERGUNTAS[atual];
    const novas = { ...respostas, [pergunta.id]: letra };
    setRespostas(novas);

    if (atual < PERGUNTAS.length - 1) {
      setTimeout(() => setAtual(atual + 1), 300);
    } else {
      setResultado(calcularResultado(novas));
      setEtapa(ETAPA.RESULTADO);
    }
  };

  const irParaWhatsApp = () => {
    window.open(CTA.url, '_blank', 'noopener,noreferrer');
  };

  // ----- INTRO -----
  if (etapa === ETAPA.INTRO) {
    return (
      <div className="quiz-page">
        <div className="quiz-intro">
          <div className="quiz-intro-logo">📓</div>
          <p className="quiz-intro-marca">Clube do Eu</p>
          <h1 className="quiz-intro-titulo">{QUIZ_META.titulo}</h1>
          <p className="quiz-intro-subtitulo">{QUIZ_META.subtitulo}</p>
          <p className="quiz-intro-tempo">⏱ {QUIZ_META.tempo}</p>
          <button
            className="btn btn-primary quiz-intro-btn"
            onClick={() => setEtapa(ETAPA.QUIZ)}
          >
            {QUIZ_META.botaoIniciar}
          </button>
          <p className="quiz-intro-privacidade">Sem cadastro. Sem julgamento. 100% gratuito.</p>
        </div>
      </div>
    );
  }

  // ----- QUIZ -----
  if (etapa === ETAPA.QUIZ) {
    const pergunta = PERGUNTAS[atual];
    return (
      <div className="quiz-page">
        <div className="quiz-card">
          <QuizQuestion
            pergunta={pergunta}
            numero={atual + 1}
            total={PERGUNTAS.length}
            resposta={respostas[pergunta.id] ?? null}
            onChange={responder}
          />
        </div>
      </div>
    );
  }

  // ----- RESULTADO -----
  return (
    <div className="quiz-page">
      <div className="quiz-card">
        <QuizResult resultado={resultado} onCTA={irParaWhatsApp} />
      </div>
    </div>
  );
}
